import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION_OAUTH,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegrationOAuth",
    method: "post",
    url: CRUD_INTEGRATION_OAUTH,
    stateKey: "message",
  },
  {
    name: "getIntegrationOAuth",
    method: "get",
    url: CRUD_INTEGRATION_OAUTH,
    stateKey: "data",
  },
  {
    name: "updateIntegrationOAuth",
    method: "put",
    url: CRUD_INTEGRATION_OAUTH,
    stateKey: "message",
  },
  {
    name: "deleteIntegrationOAuth",
    method: "delete",
    url: CRUD_INTEGRATION_OAUTH,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "IntegrationOAuth",
  apiConfig,
  customReducers,
);
const integrationOAuthSlice = slice;
// Export the slice's reducer
export default integrationOAuthSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addIntegrationOAuth,
  getIntegrationOAuth,
  updateIntegrationOAuth,
  deleteIntegrationOAuth,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect, } =
  actions;
